import { useMemo, useState } from "react";
import { CompareTool } from "./useCompareTool";
import type {
  compareItemsInterface,
  compareToolConfig,
  useCompareToolProps
} from "./interface";

const compareToolConfigDefault: compareToolConfig = {
  type: "SlideOut",
  position: "right",
  panelWidth: "50%"
};
export const useCompareTool = ({
  onClosed,
  title,
  compareFromComponent,
  compareToComponent,
  config = compareToolConfigDefault,
  hasBridgeBar = true
}: useCompareToolProps) => {
  const [showModal, setShowModal] = useState(false);
  const [itemsToCompare, setItemsToCompare] = useState<compareItemsInterface>(
    {}
  );
  const open = (compareItems: compareItemsInterface) => {
    setShowModal(true);
    setItemsToCompare(compareItems);
  };
  const Modal = useMemo(() => {
    return showModal ? (
      <CompareTool
        closeModal={() => {
          setShowModal(false);
          onClosed && onClosed();
        }}
        compareFromComponent={compareFromComponent}
        compareToComponent={compareToComponent}
        compareToolConfig={config}
        hasBridgeBar={hasBridgeBar}
        itemsToCompare={itemsToCompare}
        title={title}
      />
    ) : (
      <></>
    );
  }, [
    showModal,
    compareFromComponent,
    compareToComponent,
    hasBridgeBar,
    config,
    itemsToCompare,
    title,
    onClosed
  ]);
  return { Modal, open };
};

export * from "./interface";
